// extracted by mini-css-extract-plugin
module.exports = {"paitent_num":"BookforItem_paitent_num__q8JM9","checked":"BookforItem_checked__VJwTl"};